import { thermometer } from './thermometer';
import { indicatorLight } from './indicatorLight';
import { knifeSwitch } from './knifeSwitch';
import { toggleSwitch } from './toggleSwitch';
import { watermeter } from './watermeter';
import {myRectangle} from './myRectangle';
import {customRectangle} from './customRectangle';
import {myMultiRectangle} from './myMultiRectangle';

import {switchobj} from './switch';
import {slider} from './slider';
import {table} from './table';

// 注册自定义图形库
export function register_components() {
  (window).Le5leTopology.registerNode('thermometer', thermometer);
  (window).Le5leTopology.registerNode('indicatorLight', indicatorLight);
  (window).Le5leTopology.registerNode('knifeSwitch', knifeSwitch);
  (window).Le5leTopology.registerNode('toggleSwitch', toggleSwitch);
  (window).Le5leTopology.registerNode('watermeter', watermeter);
  (window).Le5leTopology.registerNode('myRectangle', myRectangle);
  (window).Le5leTopology.registerNode('customRectangle', customRectangle);
  (window).Le5leTopology.registerNode('myMultiRectangle', myMultiRectangle);
  (window).Le5leTopology.registerNode('switchobj', switchobj);
  (window).Le5leTopology.registerNode('slider', slider);
  (window).Le5leTopology.registerNode('table', table);
}

